import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import { useLocation, useNavigate } from "react-router-dom";

const tabs = [
  { value: "/dashboard/owner", label: "Panel rápido", icon: <DashboardRoundedIcon fontSize="small" /> },
  { value: "/dashboard/owner/clientes", label: "Clientes", icon: <GroupsRoundedIcon fontSize="small" /> },
  { value: "/dashboard/owner/calendario", label: "Calendario", icon: <CalendarMonthRoundedIcon fontSize="small" /> },
  { value: "/dashboard/owner/estadisticas", label: "Estadísticas", icon: <QueryStatsRoundedIcon fontSize="small" /> },
];

export default function OwnerWorkspaceNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const value = location.pathname.startsWith("/dashboard/owner/estadisticas")
    ? "/dashboard/owner/estadisticas"
    : location.pathname.startsWith("/dashboard/owner/calendario")
      ? "/dashboard/owner/calendario"
      : location.pathname.startsWith("/dashboard/owner/clientes")
        ? "/dashboard/owner/clientes"
        : "/dashboard/owner";

  return (
    <Box sx={{ mb: 2, borderBottom: "1px solid", borderColor: "divider" }}>
      <Tabs
        value={value}
        onChange={(_, next) => navigate(next)}
        variant="scrollable"
        scrollButtons={false}
        sx={{
          minHeight: 48,
          "& .MuiTab-root": {
            minHeight: 48,
            px: 1.8,
            textTransform: "none",
            fontWeight: 900,
            fontSize: 14,
            alignItems: "center",
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.value} value={tab.value} label={tab.label} icon={tab.icon} iconPosition="start" />
        ))}
      </Tabs>
    </Box>
  );
}
